import { useEffect, useState } from "react";
import Loader from "../../../../components/Loader/Loader";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import BankDepositRows from "./BankDepositRows";
import Select from "react-select";
import axios from "axios";
import {
  ALREADY_EXIST,
  ERROR_MESSAGE,
  ERROR_EXISTS,
  AWS_IMAGE_FOLDER_CUSTOMER,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import config from "../../../../config/config";
import { toastError, toastSuccess } from "../../../../common/Toast";
import { Link, useNavigate, useParams } from "react-router-dom";
// import ReactDatetime from "react-datetime";
import * as Yup from "yup";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import { Modal, Button } from "react-bootstrap";
import FileInput from "../../../../components/FormControls/FileInput";
import { uploadAWS } from "../../../../common/AWSHelper";
import { GetDataForTotal } from "./BankDepositRows";
import { error } from "jquery";
import { checkUserPermission } from "../../../../common/UserPermission";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../../../../components/DatePicker/CommonDatePicker";

const BankDeposits = (props) => {
  const navigate = useNavigate();
  let TotalValue = 0;
  const { id } = useParams();
  TotalValue = GetDataForTotal();
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState(moment().format("MM/DD/YYYY"));
  const [rowsData, setRowsData] = useState([]);
  const [Account, setAccount] = useState([]);
  const [SelectAccountData, setSelectAccountData] = useState(0); // set in this selected values
  const [cashbackaccountid, setcashbackaccountid] = useState(0);
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID");
  const [show, setShow] = useState(false); //Show the Categories model
  const [showtag, setShowTag] = useState(false); //Show the Tags model
  const [tagsdropdwonData, setTagsdropdwonData] = useState([]); // tags values stores
  const [selectedtags, setSelectedtags] = useState([]); //store seletcd tags
  const [ImageUrl, setImageUrl] = useState("");
  const [btnLoader, setBtnLoader] = useState({ Attachments: false });
  const [selectedImage, setSelectedImage] = useState("");
  const [changeImagename, setChangeImagename] = useState(false);
  const [cashBackAmount, setCashBackAmount] = useState(0);
  const [cashBackAmount2, setCashBackAmount2] = useState(0);
  const [selectedaccount, setSelectedAccount] = useState(0);
  const [cashback, setCashback] = useState(0);
  const [tag, setTag] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [bankpayments, setBankPayments] = useState([]);
  const [rowvalues, setRowValues] = useState(0);
  const [accountquickbookid, setAccountQuickBookId] = useState(0);
  const [cashbackquickbookaccountid, setCashbackQuickbookId] = useState(0);
  const [bankdepositquickbookid, setBankDepositQuickbookId] = useState(0);
  const [notlisted, setnotlisted] = useState([]);
  console.log(selectedtags, "selectedtags2525");
  console.log(tag, "tag");

  console.log(selectedImage, "ImageUrl===");
  console.log(ImageUrl, "ImageUrl==");

  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    setLoading(true);
    await uploadAWS(file, AWS_IMAGE_FOLDER_CUSTOMER, (data) => {
      if (data) {
        if (type === "SelectImage") {
          console.log("data: ", data);
          setImageUrl(data);
          setLoading(false);
        }
      }
    });
  };

  const callback = (val) => {
    setRowValues(val);
  };

  const validation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };
  const _handleFileChange = (e) => {
    console.log(e.currentTarget.files[0]);
    setChangeImagename(true);

    if (validation(e.target.name, e?.currentTarget?.files[0])) {
      console.log(1);
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };
  //Setting the default date as a today's date
  const today = moment();
  console.log(today.format("MM/DD/YYYY"), "today");

  // formvalues
  const [formValues, setFormValues] = useState({
    Date: today.format("MM/DD/YYYY"),
    Account: "",
    Memo: "",
    SelectImage: "",
    CashBackTo: "",
    CashBackMemo: "",
    CashBackAmount: "",
  });

  console.log(cashbackaccountid, "cashbackaccountid");

  console.log(formValues,"11111111111111111")

  const handleAmountChange = (event) => {
    console.log("sub Amount==>", event.target.value);
    setCashBackAmount2(event.target.value);
    // setCashBackAmount(parseFloat(TotalValue) - parseFloat(event.target.value));
    //  = parseFloat(TotalValue) - parseFloat(event.target.value);
  };

  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
  //     },
  //   }),
  // };

  const addTableRows = () => {
    const rowsInput = {
      // id: 0,
      BankdepositID: 0,
      CustomerID: "",
      AccountIDs: "",
      Description: "",
      PaymentMethodID: "",
      RefNo: "",
      Amount: "",
      UserType: "",
      bankdeposititemquickbookid: -1,
    };

    setRowsData([...rowsData, rowsInput]);
  };

  //   validation schema
  const validationSchema = Yup.object().shape({
    Date: Yup.string().required("Date is Required"),
    Account: Yup.string().required("Account is Required"),
  });

  const handleDate = (momentDate) => {
    setDate(moment(momentDate).format("MM/DD/YYYY"));
  };

  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
  };

  const handleChangeTableRow = (index, evnt) => {
    let id, name, values;
    name = evnt.target.name;
    values = evnt.target.value;
    console.log(name, values);
    const rowsInput = [...rowsData];
    rowsInput[index][name] = values;
    if (name == "AccountIDs") {
      rowsInput[index]["accountquickbookid"] = evnt.target.quickbookid;
    }
    if (name == "CustomerID") {
      rowsInput[index]["customerquickbookid"] = evnt.target.quickbookid;
    }
    if (name == "PaymentMethodID") {
      rowsInput[index]["paymentquickbookid"] = evnt.target.quickbookid;
    }
    // if (name == "UserType") {
    //   rowsInput[index]["IsCustomer"] = values;
    // }

    console.log(evnt, "event2904");
    setRowsData(rowsInput);
  };
  console.log(rowsData, "rowwwww");

  let AccontDDL = [];
  const manufacturedropdownvalue = Account.map((u, i) => {
    AccontDDL[i] = {
      label: u.Name,
      value: u.ID,
      Amount: u.Amount,
      QuickBookId: u.QuickbookId,
    };
  });

  let TagsList = [];
  const Tags = tagsdropdwonData.map((u, i) => {
    TagsList[i] = { label: u.Name, value: u.ID };
  });

  // close and show model pop
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handeltagsmodelClose = () => setShowTag(false);
  const handeltagsmodelShow = () => setShowTag(true);

  const handleTagsDropdowns = () => {
    // tags dropdown values
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Account`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("tags ==>", res.data.ResponseData);
        setTagsdropdwonData(res.data.ResponseData);
        return res;
      });
  };

  //changes in selected in Tags
  const handleSelectedtags = (e) => {
    setSelectedtags(Array.isArray(e) ? e.map((x) => x.value) : []);
    // setSelectedtags(e);
  };
  const [formValuesfortagmodel, setFormValuesforTagmodel] = useState({
    ID: 0,
    Tags: "",
  });
  // handleSubmit for tags model
  const handleSubmitformodeltags = async (eventObject) => {
    if (eventObject.Tags === "") {
      toastError("Please Insert Tag Name");
      return;
    }
    setLoading(true);
    axios
      .post(
        `${config.tagBaseUrl}/tags/upsert`,
        {
          id: 0,
          ecommerecetagid: 1,
          name: eventObject.Tags,
          tagtype: "Account",
          loginuserid: loginUserId,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data);

        if (res.data.ResponseCode === "SUCCESS") {
          toastSuccess(SUCCESS_MESSAGE);
          handleTagsDropdowns();
          setSelectedtags([...selectedtags, res.data.ResponseID]);
          const clearData = {
            ID: 0,
            Tags: "",
          };
          let fixvalues = formValues;
          setFormValues(fixvalues);
          setFormValuesforTagmodel(clearData);
          setShowTag(false);
          setLoading(false);
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError(ERROR_EXISTS);
          setLoading(false);
        } else {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        }
      });

    handleSubmitformodeltags();
  };

  useEffect(() => {
    // setLoading(true);
    // console.log(selectedIds,"selectedid")
    TotalValue = 0;

    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl?type=3`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("response ==>", res.data.ResponseData);

        setAccount(res.data.ResponseData);
      });

    handleTagsDropdowns();
  }, []);
  const [tableData, setTableData] = useState([]);
  const [paymentTypeDropdown, setPaymentTypeDropdown] = useState([]);
  let PaymentOption = [];
  const PaymentOpt = paymentTypeDropdown.map((u, i) => {
    PaymentOption[i] = { label: u.Paymenttypename, value: u.ID };
  });
  // const handlePayment = (index, event) => {
  //   let evnt = {
  //     target: {
  //       name: "PaymentMethodID",
  //       value: event.value,
  //     },
  //   };
  // };

  useEffect(() => {
    console.log(TagsList, "TagsList555 555");
    console.log(selectedtags, "selectedtags2565 555");

    const tagValue = selectedtags?.map((e) => Number(e));
    const filteredTagsData = TagsList?.filter((tag) =>
      tagValue?.includes(tag.value)
    );
    setTag(filteredTagsData);

    console.log(filteredTagsData, "filteredTagsData");
  }, [selectedtags, tagsdropdwonData]);

  const handletableChange = (e, index, PaymentTypeId) => {
    if (PaymentTypeId) {
      const updatedData = [...tableData];
      updatedData[index] = {
        ...updatedData[index],
        [PaymentTypeId]: e.value,
      };
      setTableData(updatedData);
    } else {
      const updatedData = [...tableData];
      updatedData[index] = {
        ...updatedData[index],
        [e.target.name]: e.target.value,
      };
      setTableData(updatedData);
    }
    console.log("tableData::>>", e);
  };
  console.log("tableData::>>", tableData);

  useEffect(() => {
    const filteredData = tableData.filter((item) => item.Checked == true);
    console.log(filteredData, "filtereddata");
    const totalcheckedData = filteredData.reduce((acc, cur) => {
      acc += Number(cur["PaymentAmount"]);
      console.log("acc", acc);
      return acc;
    }, 0);
    console.log(rowvalues, "rowvalues");
    let totaldata = parseFloat(rowvalues ? rowvalues : 0) + totalcheckedData;
    let subtotaldata = parseFloat(rowvalues ? rowvalues : 0);
    console.log(totaldata, cashBackAmount2, "totaldata");
    setSubTotal(totaldata);
    // console.log("filteredData", filteredData, totalcheckedData);
    setCashBackAmount(
      totaldata - parseFloat(cashBackAmount2 ? cashBackAmount2 : 0)
    );
  }, [cashBackAmount2, rowvalues, tableData]);

  console.log(cashBackAmount, "cashBackAmount");

  const bankdepositselectdetails = () => {
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/bankdepositselectdetails`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const newArray = res.data.ResponseData.map((obj, index) => {
          return { ...obj, RefNo: "", Checked: false };
        });

        setTableData(newArray);
        console.log("newArray", newArray);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (id == undefined) {
      bankdepositselectdetails();
    }
    axios
      .get(`${config.generalBaseUrl}/generals/paymentdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setPaymentTypeDropdown(res.data.ResponseData);
      });
  }, []);

  // console.log(date,"date")
  const filteredDatareceiving = tableData.filter((items, index) => {
    return items.Checked == true && items.PaymentTypeId != "";
  });

  console.log(filteredDatareceiving, "filtereddatareceiving");

  function hasDuplicatedPaymentQuickbookId(transactions) {
    // Filter transactions where Checked is true
    const filteredTransactions = transactions.filter(
      (transaction) =>
        transaction.Checked && transaction.PaymentQuickbookId !== 0
    );

    if (filteredTransactions.length === 0) {
      return false;
    }

    // Use a set to track seen PaymentQuickbookId
    const seenIds = new Set();

    for (const transaction of filteredTransactions) {
      if (seenIds.has(transaction.PaymentQuickbookId)) {
        return true; // Duplicate found
      }
      seenIds.add(transaction.PaymentQuickbookId);
    }

    return false; // No duplicates
  }

  const showQuickBookMessage = hasDuplicatedPaymentQuickbookId(
    filteredDatareceiving
  );
  console.log(showQuickBookMessage, "showQuickBookMessage");
 

  const handleSubmit = (values) => {
    console.log(cashbackquickbookaccountid, "cashbackquickbookaccountid");
    let data = rowsData.filter(function (rowData) {
      return rowData.name != "";
    });

    console.log(data, "data==>");

    let changedData = data.map((change) => ({
      ...change,
      UserType: change.UserType == 1 ? "Customer" : change.UserType == 2 ? "Employee" : "Supplier",
      //item?.UserType == 1 ? "Customer" :item?.UserType == 2 ? "Employee" : "Supplier",
    }));

    console.log(changedData,"changedData")

    const jsonobj = {};
    jsonobj.Deposititemsxml = changedData;

    let jsonstring = JSON.stringify(jsonobj);
    console.log("jsonstring", jsonstring);

    // For BankDeposit Receivings

    
    const filteredDatareceiving = tableData.filter((items, index) => {
      return items.Checked == true && items.PaymentTypeId != "";
    });

    const filteredquickbookbankdata = tableData.filter((items, index) => {
      return items.Checked == true && items.PaymentQuickbookId > 0;
    });

    const mappedReceivingItems = filteredDatareceiving.map((item) => {
      const mappedItem = {
        ID: item.ID,
        SaleID: item.SaleID,
        ReceivingID: item.ReceivingID,
        TransactionType: item.TransactionType,
        PaymentTypeID: item.PaymentTypeId,
        PaymentAmount: parseFloat(item.PaymentAmount).toFixed(2),
        Memo: item.Memo,
        RefNo: item.RefNo,
        PaymentQuickbookId: item.PaymentQuickbookId,
      };
      return mappedItem;
    });

    console.log(values.Date,"checkdate")

    const jsonreceivingobj = {};
    jsonreceivingobj.Depositreceivingitemsxml = mappedReceivingItems;

    let jsonreceivingstring = JSON.stringify(jsonreceivingobj);

    const jsonquickbookobj = {};
    jsonquickbookobj.Depositreceivingquickbookxml = filteredquickbookbankdata;

    let jsonreceivingquickbookstring = JSON.stringify(jsonquickbookobj);

    setLoading(true);

    axios
      .post(
        `${config.accountingBaseUrl}/chartofaccounts/bankdepositupsert`,
        {
          xmlDeposititems: jsonstring,
          xmlDepositreceivingitems: jsonreceivingstring,
          xmlDepositquickbookitems: jsonreceivingquickbookstring,
          id: id > 0 ? id : 0,
          accountid: selectedaccount,
          depositdate: moment(values.Date).format("YYYY-MM-DD"), //values.Date,
          TagIDs: selectedtags.toString(),
          subtotal: subTotal,
          total: cashBackAmount,
          cashbackaccountid: cashbackaccountid,
          cashbackmemo: values.CashBackMemo,
          cashbackamount: cashBackAmount2,
          memo: values.Memo,
          attachements: ImageUrl,
          loginuserid: loginUserId,
          accountquickbookid: accountquickbookid,
          cashbackquickbookaccountid: cashbackquickbookaccountid,
          bankdepositquickbookid: bankdepositquickbookid,
          notlisted: notlisted,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("Submit Response ==>", res.data.ResponseCode);
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          // window.location.reload();
          setRowsData([]);

          setBankDepositQuickbookId(0);
          setCashbackQuickbookId(0);
          setAccountQuickBookId(0);
          setFormValues({
            Date: moment().format("MM/DD/YYYY"),
            Account: 0,
            Memo: "",
            SelectImage: "",
            CashBackTo: 0,
            CashBackMemo: "",
            CashBackAmount: 0,
          });
          setTag([]);
          setSelectedImage("");
          setImageUrl("");
          setSelectedAccount(0);
          setCashback("");
          setCashBackAmount2(0);
          setSelectAccountData("");
          setSelectedtags([]);
          setTableData([]);
          bankdepositselectdetails();
          navigate("/bank-deposit");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Name" + ALREADY_EXIST);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleCheckboxChange = (index, row) => {
    setTableData((prevTableData) => {
      return prevTableData.map((item, i) => {
        if (
          item.PaymentQuickbookId === row.PaymentQuickbookId &&
          item.PaymentQuickbookId !== 0
        ) {
          return { ...item, Checked: !item.Checked };
        } else if (i === index) {
          return { ...item, Checked: !item.Checked };
        } else {
          return item;
        }
      });
    });
  };


  const handleHeaderCheckboxChange = () => {
    setTableData((prevTableData) => {
      const allChecked = prevTableData.every((item) => item.Checked);
      return prevTableData.map((item) => {
        return { ...item, Checked: !allChecked };
      });
    });
  };

  console.log("formvalues", formValues);
  // console.log(selectedaccount,"selectedaccount")


  useEffect(() => {
    if (id > 0) {
      axios
        .get(
          `${config.accountingBaseUrl}/chartofaccounts/bankdepositupsertdata?id=${id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          console.log(response.data.ResponseData, "1212datadatadata");
          setnotlisted(response.data.ResponseData);
        })
        .catch((error) => {});
    }
  }, []);

  useEffect(() => {
    if (id > 0) {
      axios
        .get(
          `${config.accountingBaseUrl}/chartofaccounts/bankdepositselectall?id=${id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          console.log("res", res);
          const newrowsdata = res.data.ResponseData?.DepositItems.map(
            (item, index) => {
              return {
                BankdepositID: item?.ID,
                CustomerID: item?.CustomerID,
                AccountIDs: item?.AccountID, 
                Description: item?.Description,
                PaymentMethodID: item?.PaymentMethodID,
                RefNo: item?.RefNo,
                Amount: item?.Amount,
                UserType: item?.UserType, //item?.UserType == 1 ? "Customer" :item?.UserType == 2 ? "Employee" : "Supplier",
                bankdeposititemquickbookid: item?.BankDepositItemsQuickbookId,
                accountquickbookid: item?.AccountQuickbookId,
                customerquickbookid: item?.UserQuickbookId,
                paymentquickbookid: item?.PaymentQuickbookId,
              };
            }
          );
          setRowsData(newrowsdata);
          const newdata = res.data.ResponseData?.BankDepositPayments.map(
            (item, index) => {
              return { ...item, checked: item?.Checked > 0 ? true : false };
            }
          );

          setTableData(newdata);

          const newdetailsdata = res.data.ResponseData?.DepositDetails[0];


          console.log(newdetailsdata,"newdetailsdata555")

          setSelectedAccount(newdetailsdata?.AccountID);
          setSelectAccountData(newdetailsdata?.Amount);
          setBankDepositQuickbookId(
            newdetailsdata?.BankDepositHistoryQuickbookId
          );
          setCashback(newdetailsdata?.CashbackAccountID);
          setCashbackQuickbookId(newdetailsdata?.CashbackQuickbookId);
          setAccountQuickBookId(newdetailsdata?.AccountQuickbookId);

          setFormValues({
            Date: moment(newdetailsdata?.DepositDate).format("MM/DD/YYYY"),
            Account: newdetailsdata?.AccountID,
            Memo: newdetailsdata?.Memo,
            SelectImage: newdetailsdata?.Attachments,
            CashBackTo: newdetailsdata?.CashbackAccountID,
            CashBackMemo: newdetailsdata?.CashbackMemo,
            CashBackAmount: parseFloat(newdetailsdata?.CashbackAmount).toFixed(
              2
            ),
          });
          setcashbackaccountid(newdetailsdata?.CashbackAccountID);
          // setTag(newdetailsdata?.TagIDs)
          setSelectedtags(newdetailsdata?.TagIDs.split(","));
          //       const filteredTagsData = TagsList.filter(tag => selectedtags.includes(tag.value));
          // setTag(filteredTagsData)

          setSelectedImage(newdetailsdata?.Attachments);
          setImageUrl(newdetailsdata?.Attachments);
          //  setDate( moment(res.data.ResponseData?.DepositDetails[0].DepositDate).format("MM/DD/YYYY h:mm A"))
          //  setCashBackAmount(newdetailsdata?.Total)
          setCashBackAmount2(
            parseFloat(newdetailsdata?.CashbackAmount).toFixed(2)
          );
          
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [id]);

  // console.log(cashBackAmount,"cashBackAmount")
  // console.log(selectedaccount,"selectedaccount")
  console.log(tableData, "tabledata==>");

  let accountSelect = AccontDDL.find((item, index) => item?.value == cashback);
  if (cashback === null) {
    accountSelect = cashback;
  }
  console.log(accountSelect, "accountSelect");
  console.log(SelectAccountData, "selectedaccountdata");
  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row">
              <div className="breadcrumb-position">
                {/* <h2 className="page-title">Accounting: Bank Deposit</h2> */}
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Manage Bank Deposit</li>
                </ul>
              </div>
            </div>
          </div>

          {/* <div className="card">
            
          </div> */}

          <div className="card">
            <Formik
              {...props}
              initialValues={formValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ errors, touched, handleChange }) => (
                <Form>
                  <div className="card-header">
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="row">
                          <label className="col-form-label col-md-3 form-label">
                            Date
                            <span className="text-danger">*</span>
                          </label>
                          <div className="col-md-8">
                            <Flatpickr
                              type="date"
                              className={`form-control form-control-sm ${
                                errors.Date ? "is-invalid" : ""
                              }`}
                              //   onChange={handleChange}
                              onChange={(event) => {
                                formValues.Date = event[0];
                                handleDate(event[0]);
                              }}
                              id="Date"
                              name="Date"
                              value={formValues?.Date}
                              options={{
                                dateFormat: "m/d/Y",
                                altInput: true,
                                altFormat: "m/d/Y",
                              }}
                            />
                             {/* <CommonDatePicker FinalDate={formValues?.Date} handleDateChange={handleEndDate}/> */}
                            <div className="invalid-feedback">
                              {touched.Date && errors.Date ? errors.Date : ""}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className=" row">
                          <div className="col-md-3">
                            <label className="col-form-label col-md-12 form-label">
                              Account
                              <span className="text-danger">*</span>
                            </label>
                          </div>
                          <div className="col-md-9">
                            <Select
                              className={` custom-search-select ${
                                errors.Account ? "is-invalid" : ""
                              }`}
                              value={
                                AccontDDL.find(
                                  (option) => option?.value == selectedaccount
                                ) || ""
                              }
                              options={AccontDDL}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              onChange={(evnt) => {
                                console.log(evnt, "event===>");
                                setSelectAccountData(parseFloat(evnt.Amount));
                                formValues.Account = evnt.value;
                                setSelectedAccount(evnt.value);
                                setAccountQuickBookId(evnt.QuickBookId);
                              }}
                              hideSelectedOptions={true}
                              isClearable={true}
                              id="Account"
                              name="Account"
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                            />
                            <div className="invalid-feedback">
                              {touched.Account && errors.Account
                                ? errors.Account
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-2">
                        <div className="col-md-12">
                          <div className="row col-md-12">
                            <label
                              className="col-form-label col-md-12 pt-0 ps-5 "
                              style={{ fontSize: "15px" }}
                            >
                              Balance
                            </label>
                          </div>
                          <div className="row col-md-12">
                            <span
                              className="ps-5"
                              style={{ fontWeight: "bold" }}
                            >
                              {SelectAccountData}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-2">
                        <label
                          className="col-md-7 float-end form-label "
                          style={{ fontSize: "15px" }}
                        >
                          AMOUNT
                        </label>
                        <label
                          className="col-md-7 float-end form-label "
                          style={{ fontWeight: "bold", fontSize: "20px" }}
                        >
                          ${cashBackAmount ? cashBackAmount : 0}
                        </label>
                      </div>
                    </div>
                    {/* Tags */}
                    <div className="row">
                      <div className="row mt-3">
                        <label className="form-label col-md-1">Tags</label>
                        <div className="col-md-5">
                          <div className="input-group">
                            <Select
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              // isClearable={true}
                              isMulti={true}
                              onChange={handleSelectedtags}
                              options={TagsList}
                              placeholder=""
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              id="Tags"
                              name="Tags"
                              className="w-75  custom-search-select"
                              value={tag}
                            />
                            {checkUserPermission("add-tags") && (
                              <button
                                type="button"
                                className="btn btn-sm btn-secondary ml-2"
                                data-bs-toggle="modal"
                                data-bs-target="#ManageDataModal"
                                onClick={() => handeltagsmodelShow()}
                              >
                                Add Tags
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="card-body"
                    style={{ borderBottom: "1px solid #E8EBED" }}
                  >
                    <div className="d-flex gap-4 mb-3">
                      <p className="mb-2 p-medium">
                        Select the payments included in this deposit
                      </p>
                      {/* <div className="row align-center"> */}
                      {showQuickBookMessage === true && (
                        <div
                          style={{
                            border: "1px solid var(--error-main-color)",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            width: "fit-content",
                            // margin: "15px",
                          }}
                        >
                          <b>QUICKBOOKS SYNC:</b> It is mandatory to select all
                          received payments done in a single transaction for
                          QuickBooks sync.
                        </div>
                      )}
                      {/* </div> */}
                    </div>
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">
                            <input
                              type="checkbox"
                              onClick={() => handleHeaderCheckboxChange()}
                              checked={
                                tableData.every((item) => item.Checked) == true
                              }
                              // className="form-control"
                            />
                          </th>
                          <th scope="col">No</th>
                          <th scope="col">Received From</th>
                          <th scope="col">Date</th>
                          <th scope="col">Type</th>
                          <th scope="col">Payment Method</th>
                          <th scope="col">Memo</th>
                          <th scope="col">Ref No.</th>
                          <th scope="col">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {tableData?.map((item, index) => {
                          return (
                            <>
                              <tr key={index}>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={item.Checked == true}
                                    onClick={() =>
                                      handleCheckboxChange(index, item)
                                    }
                                    // className="form-control"
                                  ></input>
                                </td>
                                <td>{index + 1}</td>
                                <td>
                                  {id > 0 ? item.Receivefrom : item.Username}
                                </td>
                                <td>
                                  {moment(item.PaymentDate).format(
                                    "MM/DD/YYYY"
                                  )}
                                </td>
                                <td>{item.TransactionType}</td>
                                {/* <td>{item.Paymenttypename}</td> */}
                                <td>
                                  <Select
                                    // onChange={(event) =>
                                    //   handlePayment(index, event)
                                    // }

                                    onChange={(e) => {
                                      handletableChange(
                                        e,
                                        index,
                                        "PaymentTypeId"
                                      );
                                    }}
                                    // value={item.Paymenttypename}
                                    value={PaymentOption.find(
                                      (el) => el.value == item.PaymentTypeId
                                    )}
                                    // )}
                                    options={PaymentOption}
                                    backspaceRemovesValue={false}
                                    controlShouldRenderValue={true}
                                    id="PaymentMethodID"
                                    name="Paymenttypename"
                                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                                    className="custom-search-select"
                                  />
                                </td>
                                <td>
                                  <input
                                    className="form-control form-control-sm"
                                    // name="Comment"
                                    name="Memo"
                                    onChange={(e) =>
                                      handletableChange(e, index)
                                    }
                                    defaultValue={item.Memo}
                                  />
                                </td>
                                <td>
                                  <input
                                    className="form-control form-control-sm"
                                    name="RefNo"
                                    onChange={(e) =>
                                      handletableChange(e, index)
                                    }
                                    defaultValue={
                                      parseInt(item.RefNo) >= 0
                                        ? item.RefNo
                                        : ""
                                    }
                                  />
                                </td>
                                <td>
                                  {parseFloat(
                                    item.PaymentAmount ? item.PaymentAmount : 0
                                  ).toFixed(2)}
                                </td>
                              </tr>
                            </>
                          );
                        })}
                      </tbody>
                    </table>

                    <div className="">
                      <div className="row justify-content-end mt-4">
                        <div className="col-md-2 text-end">
                          <b>Total</b>
                        </div>
                        <div className="col-md-2 text-end me-5">
                          {tableData.reduce((acc, curr) => {
                            return acc + Number(curr["PaymentAmount"]);
                          }, 0)}
                        </div>
                      </div>
                      {/* <div>Total</div> */}
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="table">
                      {/* <h6 className="mb-2"> */}
                      <p className="p-medium mb-2">Add funds to this deposit</p>
                      {/* </h6> */}
                      <table className="table">
                        <thead>
                          <tr>
                            <th width="4%">No</th>
                            <th width="15%">Received From</th>
                            <th width="15%">Account</th>
                            <th width="15%">Description</th>
                            <th width="15%">Payment Method</th>
                            <th width="15%">Ref No.</th>
                            <th width="15%">Amount</th>
                            <th width="5%">Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          <BankDepositRows
                            rowsData={rowsData}
                            deleteTableRows={deleteTableRows}
                            handleChange={handleChangeTableRow}
                            callback={callback}
                          />
                        </tbody>
                      </table>
                    </div>

                    <div className="form-group row mb-4">
                      <div className="row">
                        <div className="col-md-2 ">
                          <button
                            type="button"
                            className="btn btn-secondary   btn-sm pull-left mt-3"
                            onClick={addTableRows}
                          >
                            <i className="fa fa-plus fa-sm" /> Add
                          </button>
                        </div>

                        <div className="col-md-10 pt-3">
                          <label
                            className="col form-label float-end"
                            style={{ fontSize: "20px", fontWeight: "bold" }}
                          >
                            ${rowvalues}
                          </label>
                          <label className="col form-label float-end">
                            Other Funds Total
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div className="form-group row">
                          <label className="col-form-label col-md-2 form-label">
                            Memo
                          </label>
                          <div className="col-md-10 mt-2">
                            <Field
                              as="textarea"
                              id="Memo"
                              name="Memo"
                              rows={5}
                              cols={5}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>

                      {/* row 5 */}
                      <div className="col-sm-6">
                        <div className="col">
                          <div className="form-group row">
                            <div className="col-md-3">
                              <label className="col-form-label col-md-12 form-label">
                                Attachments
                              </label>
                            </div>
                            <div className="col-md-9">
                              <FileInput
                                id="SelectImage"
                                name="SelectImage"
                                value={selectedImage}
                                accept="image/*"
                                handleChange={_handleFileChange}
                                className="form-control form-control-sm"
                              />
                            </div>
                          </div>

                          <div
                            className={`${
                              ImageUrl ? "" : selectedImage ? "" : "d-none"
                            } form-group row`}
                          >
                            <label className="col-form-label col-md-4 form-label"></label>
                            <div className="col-md-8">
                              <img
                                src={`${ImageUrl ? ImageUrl : selectedImage}`}
                                alt="Category Image"
                                className="ImagePreviewSize"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card-footer">
                    <div className="row">
                      <div className="col-sm-4">
                        <div className="row">
                          <label className="col-form-label col-md-6 form-label">
                            Cash Back Goes To.
                          </label>
                          <div className="col-md-6">
                            <Select
                              onChange={(e) => {
                                console.log(e, "cashbackaccountideeeee");
                                setcashbackaccountid(e.value);
                                setCashback(e ? e.value : null);
                                setCashbackQuickbookId(e.QuickBookId);
                              }}
                              options={AccontDDL}
                              backspaceRemovesValue={false}
                              controlShouldRenderValue={true}
                              hideSelectedOptions={true}
                              isClearable={true}
                              id="CashBackTo"
                              name="CashBackTo"
                              styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                              value={accountSelect ? accountSelect : null}
                              className="custom-search-select"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group row">
                          <label className="col-form-label col-md-5 form-label">
                            Cash Back Memo
                          </label>
                          <div className="col-md-7">
                            <Field
                              type="text"
                              id="CashBackMemo"
                              name="CashBackMemo"
                              rows={5}
                              cols={5}
                              className="form-control-sm form-control"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group row">
                          <label className="col-form-label col-md-6 form-label">
                            Cash Back Amount
                          </label>
                          <div className="col-md-6">
                            <input
                              type="number"
                              id="CashBackAmount"
                              className="form-control form-control-sm "
                              name="CashBackAmount"
                              onChange={(event) => {
                                handleAmountChange(event);
                              }}
                              rows={5}
                              cols={5}
                              value={cashBackAmount2}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <label
                          className="col form-label float-end"
                          style={{ fontSize: "20px", fontWeight: "bold" }}
                        >
                          ${cashBackAmount ? cashBackAmount : 0}
                        </label>
                        <label className="col form-label float-end">
                          Total
                        </label>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "1rem",
                        justifyContent: "flex-end",
                      }}
                    >
                      <button
                        type="submit"
                        className="btn btn-sm btn-primary pull-left mt-2 mb-3"
                        // onClick={handleSubmit}
                      >
                        Save & New
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>

      {/* model for Tags Add*/}
      <Modal
        show={showtag}
        onHide={handleClose}
        className="modal-lg"
        id="ManageDataModal"
      >
        <Modal.Header>
          <Modal.Title>Add Tags </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handeltagsmodelClose}
          >
            x
          </button>
        </Modal.Header>
        <Formik
          {...props}
          initialValues={formValuesfortagmodel}
          onSubmit={handleSubmitformodeltags}
          enableReinitialize
        >
          {({ values, errors, touched, handleChange, handleBlur }) => (
            <Form>
              <Loader loading={loading} />
              <div className="modal-body">
                <div className="form-group row">
                  <label className="col-form-label col-md-3 align-center">
                    Tags
                  </label>
                  <div className="col-md-9 mt-2">
                    <Field
                      type="text"
                      name="Tags"
                      id="Tags"
                      placeholder="Enter Tag Name"
                      className="form-control form-control-sm"
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="col-lg-12 justify-content-right">
                  <button type="submit" className="btn btn-primary btn-md me-2">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-dark btn-md me-1"
                    onClick={handeltagsmodelClose}
                  >
                    Close
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default BankDeposits;
